import React from "react";
import { Button } from "aible";

import MarketTile from "components/Market/MarketTile/MarketTile";

import styles from "./style.module.css";

const MarketConsultants = (props) => {
  const { type, updateIsCreateConsultant, hideSearch } = props;
  const renderSidebar = () => {
    const specialities = [
      "Data Transformation",
      "Data Exploration",
      "Blueprint Creation",
      "AI Creation",
      "AI Deployment"
    ];

    const experienceLevels = ["1-5 Projects", "6-10 Projects", "11+ Projects"];

    const generateCheckboxes = (data) => {
      return data.map((speciality) => (
        <div className={styles.checkboxSection} key={speciality}>
          <input style={{ margin: "0px" }} type="checkbox" />
          <div style={{ marginLeft: "10px" }}>{speciality}</div>
        </div>
      ));
    };
    return (
      <div className={styles.sidebarContainer}>
        <div className={styles.sidebarSection}>
          <Button type="primary" onClick={() => updateIsCreateConsultant(true)}>
            I am Available for Hire
          </Button>
        </div>
        <div className={styles.sidebarSection} style={{ fontWeight: "bold", fontSize: "16px" }}>
          Search Consultants
        </div>
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Keyword Search</div>
          <input placeholder="Search Keywords" />
        </div>
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Location</div>
          <input placeholder="Add a location" />
        </div>
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Speciality</div>
          {generateCheckboxes(specialities)}
        </div>
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Experience Level</div>
          {generateCheckboxes(experienceLevels)}
        </div>
        <div className={styles.sidebarSection}>
          <div className={styles.sidebarSectionTitle}>Price Range</div>
          <div className={styles.rangeInputs}>
            <input style={{ marginRight: "5px", width: "50%" }} placeholder="Min" />
            <input style={{ width: "50%" }} placeholder="Max" />
          </div>
        </div>
      </div>
    );
  };

  const renderGridTiles = () => {
    const { consultants, updateHireConsultant, deleteConsultant } = props;

    const numberToAdd = consultants.length % 3;
    if (numberToAdd === 1) {
      consultants.push({});
    } else if (numberToAdd === 2) {
      consultants.push({});
      consultants.push({});
    }

    return (
      <div className={styles.gridTilesTable}>
        {consultants.map((consultant, index) => {
          if (consultant.title) {
            return (
              <div key={index} className={styles.gridTilesTableColumn}>
                <MarketTile
                  data={consultant}
                  type={type}
                  updateHireConsultant={updateHireConsultant}
                  updateIsCreateConsultant={updateIsCreateConsultant}
                  deleteConsultant={deleteConsultant}
                />
              </div>
            );
          }
          return (
            <div key={index} className={styles.gridTilesTableColumn}>
              {" "}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <React.Fragment>
      {hideSearch !== true && renderSidebar()}
      <div className={styles.consultantsMainContainer}>
        <div className={styles.mainContainerHeader}>Consultants Available for Hire</div>
        <div>{renderGridTiles()}</div>
      </div>
    </React.Fragment>
  );
};

export default MarketConsultants;
